export { HeroVideoVariation as default } from './HeroVideoVariation';
